import React from 'react';
import StreetFi from './StreetFi';

function App() {
  return <StreetFi />;
}

export default App;
